define('../app/fukit/view/block/full.width.layout.view',['require','exports','module','uikit/uikit','../../helpers/extend.util','../common/page.header.view','./vertically.spaced.components.container.view'],function(require, exports, module) {
  //prettier-ignore
  var UIKit                                   = require('uikit/uikit'),
      ExtendUtil                              = require('../../helpers/extend.util'),
      PageHeaderView                          = require('../common/page.header.view'),
      VerticallySpacedComponentsContainerView = require('./vertically.spaced.components.container.view');


  var FullWidthLayoutView = UIKit.ItemView.extend({

    className: 'page',

    template: function() {
      return '<ui name="pageHeaderView" /><ui name="contentColumnView" />'
    },

    internalViewOptions: {
      pageHeaderView: ExtendUtil.extendOptionValueWithDefaults('pageHeader', {
        type: PageHeaderView
      }),
      contentColumnView: ExtendUtil.extendOptionValueWithDefaults('contentColumn', {
        type: VerticallySpacedComponentsContainerView
      })
    }
  });

  module.exports = FullWidthLayoutView;
});

